import * as React from "react";
import i18n from "i18n";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles,
  Chip,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import { RateLibraryService } from "modules/rateLibrary/RateLibraryService";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import * as libLocations from "modules/rateLibrary/assets/rateLibraryLocation";
import { observer } from "mobx-react";

import ReactSelect from "common/components/ReactSelect";
import { ThreeSixty } from "@material-ui/icons";
import { classNames } from "react-select/lib/utils";

const styles = (theme) => ({
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
  },
  chip: {
    margin: "0px 5px",
  },
  dialogOverflow: {
    overflowY: "visible!important" as any,
  },
});

type IProps = {
  classes: any;
};

@observer
class EditLocation extends React.Component<IProps> {
  state = {
    location: Array(),
  };

  handleClose = () => {
    RateLibraryStore.openUpdateLocationDialog = false;
  };

  handleEnter = () => {
    let locations = Array();
    let dataLocation = RateLibraryStore.editLocation
      ? RateLibraryStore.editLocation
      : [];
    dataLocation.forEach((element) => {
      locations.push(element);
    });
    this.setState({ location: locations });
  };

  handleChange = (event) => {
    this.setState({ location: event });
  };

  handleChangeLoc = (event) => {
    this.setState({ location: event.target.value });
  };

  handleUpdateLocation = async () => {
    for (let j = 0; j < this.state.location.length; j++) {
      for (let i = 0; i < libLocations.availableLocations.length; i++) {
        if (
          this.state.location[j].label ===
          libLocations.availableLocations[i].label
        ) {
          this.state.location[j].value =
            libLocations.availableLocations[i].value;
        }
      }
    }
    await RateLibraryService.changeRateLibraryLocation(
      RateLibraryStore.rateLibraryLocationRef,
      this.state.location.map((location) => location.value)
    );
    RateLibraryStore.openUpdateLocationDialog = false;
  };

  handleDeleteChip = (data) => () => {
    this.setState((state) => {
      const location = [...this.state.location];
      const chipToDelete = this.state.location.indexOf(data);
      location.splice(chipToDelete, 1);
      return { location };
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={RateLibraryStore.openUpdateLocationDialog}
        onClose={this.handleClose}
        onEnter={this.handleEnter}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.dialogOverflow }}
      >
        <DialogTitle id="form-dialog-title">
          {i18n.rateLibraries.editLocation}
        </DialogTitle>
        <DialogContent style={{ width: 600, overflowY: "visible" }}>
          <FormControl className={classes.input}>
            <ReactSelect
              listValues={libLocations.availableLocations.map(
                (location) => location.label
              )}
              handleChange={this.handleChange}
              value={this.state.location}
              placeholder={i18n.rateLibraries.layerAdd.locationPlaceholder}
              isMulti
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="secondary">
            {i18n.cancel}
          </Button>
          <Button
            disabled={this.state.location.length == 0}
            onClick={this.handleUpdateLocation}
            color="primary"
          >
            {i18n.update}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(EditLocation);



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/EditLocation.tsx